import { z } from 'zod';
import PackageProgressPage from '@pages/PackageProgress';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/connect/_authenticated/packageProgress')({
  component: PackageProgressPage,
  validateSearch: z.object({
    trackingId: z.string(),
  }),
});
